(function () {

  document.querySelectorAll('.bh-collection-slider').forEach(function(section){

    const track = section.querySelector('.bh-collection-slider__track');
    const items = section.querySelectorAll('.bh-collection-slider__product');
    const nextBtn = section.querySelector('.bh-next');
    const prevBtn = section.querySelector('.bh-prev');

    if(!track || !items.length) return;

    let index = 0;

    function visibleItems(){
      if(window.innerWidth >= 1100) return 6;
      if(window.innerWidth >= 768) return 4;
      return 2;
    }

    function maxIndex(){
      return Math.max(items.length - visibleItems(), 0);
    }

    function update(){
      const shift = (100 / visibleItems()) * index;
      track.style.transform = `translateX(-${shift}%)`;
    }

    function next(){
      index++;
      if(index > maxIndex()){
        index = 0;
      }
      update();
    }

    function prev(){
      index--;
      if(index < 0){
        index = maxIndex();
      }
      update();
    }

    nextBtn?.addEventListener('click', function(){
      next();
    });

    prevBtn?.addEventListener('click', function(){
      prev();
    });

    setInterval(next, 5000);

    window.addEventListener('resize', function(){
      update();
    });

    update();

  });

})();